<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">{{details.title}}</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/all-categories">Categories</router-link>
                                    </li>
                                    <li class="breadcrumb-item">
                                        <a href="#" @click.prevent="$router.go(-1)">{{details.category.name}}</a>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">{{details.uniqueId}}</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <section class="product-details-area pt-30 pb-90">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-5">
                        <div class="">
                            <carousel :navigationEnabled="true" :paginationEnabled="false" :autoplayTimeout="3000"
                                      :autoplay="true" :perPage="1"
                                      :autoplayHoverPause="true" :perPageCustom="[[768, 1], [1024, 1], [360, 1]]">
                                <slide class="slide" style="padding: 15px;" v-for="pic in details.files" :key="pic.id">
                                    <a data-fancybox="gallery" :href="pic.largePath" style="display: contents">
                                        <img v-lazy="pic.filePath">
                                    </a>
                                </slide>
                            </carousel>
                        </div>

                        <div class="blog-thumb-list m-auto">
                            <carousel :navigationEnabled="true" :paginationEnabled="false" :autoplayTimeout="5000"
                                      :autoplay="true" :perPage="4"
                                      :autoplayHoverPause="true" :perPageCustom="[[768, 4], [1024, 4], [360, 4]]" style="display: block">
                                <div class="item" v-for="pic in details.files" :key="pic.id"
                                     style="width: 100px; height: 100px">
                                    <a data-fancybox="gallery" :href="pic.largePath" style="display: contents">
                                        <img v-lazy="pic.filePath" alt="details">
                                    </a>
                                </div>
                            </carousel>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-7">
                        <div class="product-details-content mt-30">
                            <div class="product-details-title">
                                <h4 class="title">{{details.title}}</h4>
                            </div>

                            <div class="product-details-con">
                                <span>Ksh {{details.price | formatNumber}}</span>
                                <div>
                                    <table class="table ml-0 mr-0 mt-2 table-borderless">
                                        <tbody>
                                        <tr>
                                            <th>Category</th>
                                            <td>{{details.category.name}}</td>
                                        </tr>
                                        <tr>
                                            <th>Sub-Category</th>
                                            <td>{{details.subcategory.name}}</td>
                                        </tr>
                                        <tr>
                                            <th>Brand</th>
                                            <td>{{details.brand.name}}</td>
                                        </tr>
                                        <tr v-if="details.quantity">
                                            <th>Quantity</th>
                                            <td>{{details.quantity}}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="product-details-cart d-flex align-items-center">
                                <div class="product-quantity" id="quantity" v-if="details.status == 1">
                                    <vue-numeric-input  v-model="value" :min="1" :max="10" :step="1"></vue-numeric-input>
                                </div>
                                <div class="add-cart">
                                    <a href="#" @click.prevent="addToCart" v-if="details.status == 1">Add to cart</a>
                                    <button type="button" id="no-auth-btn" v-if="details.status == 0">Out of stock</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="bg-white">
            <div class="container">
                <div class="row p-3">
                    <div class="col-lg-6">
                        <h1>Product Description</h1>
                        <div v-html="details.description"></div>
                    </div>
                    <div class="col-lg-6"></div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import VueNumericInput from "vue-numeric-input";
    export default {
        name: "ProductDetails",
        components: {
            VueNumericInput
        },
        data() {
            return {
                details: [],
                productId: this.$route.params.productId,
                value: 1
            }
        },
        methods: {
            visited(){
                try {
                    this.axios.post('visited', {
                        product_id: this.productId
                    })
                }catch (e) {
                    throw new Error(e);
                }
            },
            addToCart() {
                try {
                    this.$store.dispatch('addProductToCart', {
                        product: this.details,
                        quantity: this.value
                    });
                    this.$swal({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        icon: 'success',
                        title: this.details.title + ' added to cart!',
                    })
                } catch (e) {
                    throw new Error(e);
                }
            },

            getDetails() {
                this.axios.get("/shopLocal/details/" + this.productId).then(({data}) => ([this.details = data]));
            }

        },
        created() {
            this.getDetails();
            this.visited();
        }
    }
</script>

<style scoped>
    .slide {
        align-items: center;
        box-sizing: border-box;
        color: #fff;
        display: flex;
        height: 450px;
        justify-content: center;
    }

    img {
        height: 100%;
        object-fit: cover;
        object-position: center;
        width: 100%;
    }

    #desc p span{
        font-size: 10px;
    }
    #no-auth-btn {
        border: 1px solid #fb0000;
        background: #fb0000;
        color: #fff;
        border-radius: 30px;
        padding: 0 45px;
        line-height: 50px;
        text-transform: uppercase;
        font-weight: 600;
        font-size: 14px;
        margin-top: 27px;
    }
</style>